var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcYahoo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "40px",
    height: "40px",
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "03-Appointment-expand",
    transform: "translate(-656.000000, -308.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-15",
    transform: "translate(225.000000, 147.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-24",
    transform: "translate(20.000000, 161.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-21",
    transform: "translate(411.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#1DB4CF",
    x: 0,
    y: 0,
    width: 40,
    height: 40,
    rx: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.5154184,16.5809093 L28.7138515,16.5809093 C28.4804951,16.6323032 28.2749193,16.6788356 28.1360167,16.7073106 C27.5241507,16.8719102 21.9284591,21.2119222 21.5575891,22.2773052 C21.4770256,22.6447026 21.5666178,26.2124161 21.6471813,26.7485802 C22.0159677,26.8305327 24.6787307,26.7596924 25.1669734,26.8409504 L25.1086343,27.9431426 C24.6308093,27.9063334 21.2464473,27.9153621 19.3163955,27.9153621 C18.3357431,27.9153621 15.1819594,28.0237062 14.2138082,27.9952311 L14.3964651,26.9451274 C14.9277676,26.9055402 17.1272904,27.0437482 17.6092825,26.5284196 C17.8488895,26.2735333 17.7738821,22.8836151 17.692624,22.3113364 C17.4884372,21.6980814 12.5844806,15.5537245 11.3024095,14.5452915 L8,14.5452915 L8,13 L19.1399892,13 L19.1399892,13.1062605 C19.1497124,13.1062605 19.1684643,13.1076495 19.1781874,13.1097331 L19.1399892,13.37087 L19.1399892,14.5439025 L15.7813241,14.5439025 C17.2786943,16.7330076 19.4254341,19.3770188 20.3408023,20.6458941 L24.826662,16.5802147 L22.161121,16.5802147 L21.7840004,15.0363122 L31.5530208,15.0363122 L31.4807915,15.1467398 C31.4877366,15.1467398 31.5037104,15.1481288 31.5148226,15.1481288 L30.8175315,16.1600343 C30.8105864,16.1600343 30.8015577,16.1614234 30.7960016,16.1635069 L30.5154184,16.5809093 Z M29.7570101,25.1380045 L31.2550747,25.2588497 L32.997608,18.4991543 C32.7073015,18.4880421 30.0605123,18.2380174 29.7167284,18.1692606 L29.7570101,25.1380045 Z M29.4993458,26.2228338 L29.5083744,27.8723023 L30.2667827,27.9375865 L31.084919,27.9987037 L31.3252206,26.3832663 L30.4626354,26.3402065 L29.4993458,26.2228338 Z",
    id: "Shape",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcYahoo);
export default __webpack_public_path__ + "static/media/icYahoo.8d59d705e3393c86f62b796eb0a1de4f.svg";
export { ForwardRef as ReactComponent };